import { createDomain } from 'effector-root';

const domain = createDomain('Print files (Page)');

export const onPageStarted = domain.event();